import { FC } from "react";
import ArrowLink from "@/components/ui/arrow-link";
import { TechnologyResource } from "@/api/generated-api";
import S from "./index.module.scss";
import Image from "next/image";
import { useTranslations } from "next-intl";

interface ITechnologiesCard {
  item: TechnologyResource;
}

const TechnologiesCard: FC<ITechnologiesCard> = ({ item }) => {
  const t = useTranslations();

  return (
    <div className={S.card}>
      <Image className={S.cardImage} src={item.image} alt="technologies" width={660} height={320} />
      <div className={S.cardInfo}>
        <h3 className={S.cardTitle}>{item.title}</h3>
        <span className={S.cardDescription}>{item.description}</span>
        <ArrowLink text={t("findOutMore")} url={`technologies/${item.id}`} />
      </div>
    </div>
  );
};

export default TechnologiesCard;
